// extracted by mini-css-extract-plugin
module.exports = {"root":"warranty-documents-container_root__-iaRw","header":"warranty-documents-container_header__1XAtv"};